import React from 'react'
import { styled } from 'styletron-react'
import { padding, margin } from 'lostyle'
import { media, sizes, palette, font } from '../../style'

const maxWidthStyles = {

  maxWidth: sizes.blog.maxWidth.desktop,
  marginLeft: 'auto',
  marginRight: 'auto',
  marginTop: sizes.spacing.xxl,
  ...padding({
    x: sizes.spacing.gutter.mobile
  }),
  ...media('tablet', {
    marginTop: sizes.spacing.huge,
    ...padding({
      x: sizes.spacing.gutter.desktop
    }),
  }),
}
export const H1 = styled('h1', ({ $maxWidth }) => ({
  ...margin(0),
  letterSpacing: '-.04em',
  fontSize: '34px',
  lineHeight: '1.2em',
  fontWeight: 600,
  ...media('tablet', {
    fontSize: '42px',
    lineHeight: '1.1em',
  }),
  ...($maxWidth && {
    ...maxWidthStyles
  }),
}))
H1.displayName = 'Headings.H1'

export const H2 = styled('h2', ({ $maxWidth }) => ({
  ...margin(0),
  letterSpacing: '-.04em',
  fontSize: '34px',
  lineHeight: '1.2em',
  fontWeight: 600,
  ...media('tablet', {
    fontSize: '42px',
    lineHeight: '1.1em',
  }),
  ...($maxWidth && {
    ...maxWidthStyles
  }),
}))
H2.displayName = 'Headings.H2'

export const H3 = styled('h3', ({ $maxWidth }) => ({
  ...margin(0),
  letterSpacing: '-.04em',
  fontSize: '30px',
  lineHeight: '1.15',
  fontWeight: 600,
  ...media('tablet', {
    fontSize: '34px',
  }),
  ...($maxWidth && {
    ...maxWidthStyles
  }),
}))
H3.displayName = 'Headings.H3'

export const H4 = styled('h4', ({ $maxWidth }) => ({
  ...margin(0),
  letterSpacing: '-.04em',
  fontSize: '22px',
  lineHeight: '1.22',
  fontWeight: 600,
  ...media('tablet', {
    fontSize: '26px',
  }),
  ...($maxWidth && {
    ...maxWidthStyles
  }),
}))
H4.displayName = 'Headings.H4'

export const H5 = styled('h5', ({ $maxWidth }) => ({
  ...margin(0),
  ...($maxWidth && {
    ...maxWidthStyles
  }),
}))
H5.displayName = 'Headings.H5'

export const H6 = styled('h6', ({ $maxWidth }) => ({
  ...margin(0),
  ...($maxWidth && {
    ...maxWidthStyles
  }),
}))
H6.displayName = 'Headings.H6'

export default function Headings({ level, children, maxWidth, ...rest }) {
  switch (level) {
    case 1:
      return <H2 {...rest} $maxWidth="true">{children}</H2>
    case 2:
      return <H2 {...rest} $maxWidth="true">{children}</H2>
    case 3:
      return <H3 {...rest} $maxWidth="true">{children}</H3>
    case 4:
      return <H4 {...rest} $maxWidth="true">{children}</H4>
    case 5:
      return <H5 {...rest} $maxWidth="true">{children}</H5>
    case 6:
      return <H6 {...rest} $maxWidth="true">{children}</H6>
    default:
      return <H3 {...rest} $maxWidth="true">{children}</H3>
  }
}


// WEBPACK FOOTER //
// ./src/components/Headings/index.js